import React from 'react'

import { useQuote } from '../hooks/useQuote'
import { CoverBenefits } from './CoverBenefits'

const carBenefits = [
  {
    description: 'Repairs guaranteed for 3 years when you use an approved repairer',
    info: 'Provided you use one of our approved repairers, we’ll guarantee any repairs made to your car as part of a claim for 3 years.',
  },
  {
    description: 'Free courtesy car',
    info: 'If your car’s out of action while it’s being repaired, we’ll sort out a temporary replacement.',
  },
  {
    description: 'Windscreen cover',
    info: 'You’re covered for replacement or repair of windows, windscreen or sunroof (minus any excess), as long as you use an approved glass repairer.',
  },
  {
    description: 'Uninsured driver cover',
    info: "If you’re involved in an accident with an uninsured driver that isn’t your fault, your No Claims Discount won't be affected and you won’t have to pay an excess.",
  },
  {
    description: 'Misfuelling cover',
    info: 'You’re covered for any repairs and damage caused by misfuelling (minus any excess) - and we’ll even put 10 litres of the right fuel back in your tank.',
  },
  { description: 'Replacement key cover', info: 'If your keys are lost or stolen, you’ll be covered to replace them.' },
  {
    description: 'Battery cover',
    info: 'We’ll cover your car’s battery, whether it’s leased from the manufacturer or not.',
    electricOnly: true,
  },
  {
    description: 'Charging cables cover',
    info: 'If charging cables or charging accessories attached to your car are stolen or damaged as a result of an accident, fire or attempted theft, the insurer will pay to repair or replace them.',
    electricOnly: true,
  },
]

const getCustomerBenefits = (hasChildren: number) => {
  const customerBenefits = [
    {
      description: 'Personal accident cover for you and your spouse',
      info: 'You’re covered for up to £7,500 during your policy for injuries that occur in any car, or getting in or out of any car.',
    },
    {
      description: 'Personal belongings cover',
      info: 'You can get up to £500 to cover stuff that’s stolen or damaged in your car as the result of an incident.',
    },
  ]
  if (hasChildren)
    customerBenefits.push({
      description: 'Child car seat cover',
      info: 'If your child’s car seat is damaged in an accident or stolen, we’ll replace it with a similar one.',
    })
  return customerBenefits
}

const getOverviewBenefits = (ncd: number) => {
  return [
    {
      description: `Protection of your ${ncd} years No Claims Discount`,
      info: 'Even if you make a claim with us your No Claims Discount won’t go down.',
    },
    {
      description: 'Comprehensive cover for driving in the EU',
      info: 'You’re covered in any European Union country, as well as Andorra, Norway, Iceland and Switzerland, for up to 90 days in any one 12-month period. After that, you’ll only get the minimum compulsory insurance as required by EU law. You’ll also get the minimum compulsory insurance when driving in Serbia.',
    },
  ]
}

interface CoverBenefitsWrapperProps {
  hasChildren: number
  ncd: number
}

export const CoverBenefitsWrapper = ({ hasChildren, ncd }: CoverBenefitsWrapperProps) => {
  const quote = useQuote()
  return (
    <div className="LoNotSensitive">
      <CoverBenefits
        benefitsOverview={getOverviewBenefits(ncd)}
        customerBenefits={getCustomerBenefits(hasChildren)}
        carBenefits={carBenefits}
        isElectric={quote?.details.vehicle.isElectricVehicle}
        className="cover-benefits"
      />
    </div>
  )
}
